import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TalentAuthProvider } from './contexts/TalentAuthContext';
import { CustomerAuthProvider } from './contexts/CustomerAuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import CustomerProtectedRoute from './components/common/CustomerProtectedRoute';
import PlaceholderPage from './components/common/PlaceholderPage';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import Categories from './components/categories/Categories';
import Clients from './components/clients/Clients';
import Talent from './components/talent/Talent';
import Settings from './components/settings/Settings';
import CMS from './components/cms/CMS';
import PageDisplay from './components/public/PageDisplay';
import PostDisplay from './components/public/PostDisplay';
import BookingManagement from './components/bookings/BookingManagement';
import ServiceProviderManagement from './components/providers/ServiceProviderManagement';
import { ServiceManagement } from './components/services';
import ReviewsModeration from './components/reviews/ReviewsModeration';
import AdminSettings from './components/settings/AdminSettings';
import HomePage from './components/public/HomePage';
import SearchResults from './components/public/SearchResults';
import { InquiriesManagement, InquiryDetail } from './components/inquiries';
import TalentLogin from './components/talent/TalentLogin';
import UniversalRegister from './components/auth/UniversalRegister';
import TalentRegister from './components/talent/TalentRegister';
import TalentDashboard from './components/talent/TalentDashboard';
import TalentProfile from './components/talent/TalentProfile';
import TalentLayout from './components/talent/TalentLayout';
import CustomerLogin from './components/customer/CustomerLogin';
import CustomerForgotPassword from './components/customer/CustomerForgotPassword';
import CustomerResetPassword from './components/customer/CustomerResetPassword';
import CustomerDashboard from './components/customer/CustomerDashboard';
import ServiceInquiry from './components/customer/ServiceInquiry';
import CustomerMessages from './components/customer/CustomerMessages';
import { TalentProfileEdit, TalentServices, TalentInquiries } from './components/talent';
import TalentPortfolio from './components/talent/TalentPortfolio';
import TalentPlaceholder from './components/talent/TalentPlaceholder';
import TalentReviews from './components/talent/TalentReviews';
import MembershipManagement from './components/talent/MembershipManagement';
import MembershipSelection from './components/talent/MembershipSelection';
import MembershipSuccess from './components/talent/MembershipSuccess';
import MembershipFailed from './components/talent/MembershipFailed';

import AdminMembershipManagement from './components/talent/AdminMembershipManagement';
import AdminSubscriptionPlans from './components/admin/AdminSubscriptionPlans';
import CustomerManagement from './components/users/CustomerManagement';
import TalentForgotPassword from './components/talent/TalentForgotPassword';
import TalentResetPassword from './components/talent/TalentResetPassword';
import NotificationsPage from './components/notifications/NotificationsPage';

import './App.css';
import Listing from './components/public/listing';
import Detail from './components/public/detail';
import Partnerlogin from './components/public/partnerlogin';
import Partnersignup from './components/public/partnersignup';
import Categorypage from './components/public/categorypage';
import ContactUs from './components/public/ContactUs';
import About from './components/public/about';
import Blog from './components/public/blog';
import Blogdetail from './components/public/blogdetail';
import Pricing from './components/public/pricing';
import TermsOfService from './components/public/TermsOfService';
import PrivacyPolicy from './components/public/PrivacyPolicy';
import RefundPolicy from './components/public/RefundPolicy';
import ScrollToTop from './utils/ScrollToTop';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <TalentAuthProvider>
          <CustomerAuthProvider>
            <div className="App">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchResults />} />
                 <Route path="/listing" element={<Listing />} />
                  <Route path="/detail/:id" element={<Detail />} />
                  <Route path="/partnerlogin" element={<Partnerlogin />} />
                  <Route path="/partnersignup" element={<Partnersignup />} />
                  <Route path="/categories" element={<Categorypage />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/blogdetail" element={<Blogdetail />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/refund-policy" element={<RefundPolicy />} />
                  <Route path="/refunds" element={<RefundPolicy />} />
                  <Route path="/page/:slug" element={<PageDisplay />} />
                  <Route path="/post/:slug" element={<PostDisplay />} />

                {/* Universal Login Route */}

                <Route path="/talent/register" element={<TalentRegister />} />
                
                <Route path="/login" element={<TalentLogin />} />
                
                {/* Universal Registration Route */}
                <Route path="/register" element={<UniversalRegister />} />
                
                {/* Admin Auth Routes */}
                <Route path="/admin/login" element={<Login />} />

                {/* Admin Protected Routes */}
                <Route path="/dashboard" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } />
                <Route path="/admin" element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } />
                <Route path="/admin/categories" element={
                  <ProtectedRoute>
                    <Categories />
                  </ProtectedRoute>
                } />
                <Route path="/clients" element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                } />
                <Route path="/talent" element={
                  <ProtectedRoute>
                    <Talent />
                  </ProtectedRoute>
                } />
                <Route path="/services" element={
                  <ProtectedRoute>
                    <ServiceManagement />
                  </ProtectedRoute>
                } />
                <Route path="/customers" element={
                  <ProtectedRoute>
                    <CustomerManagement />
                  </ProtectedRoute>
                } />
                <Route path="/bookings" element={
                  <ProtectedRoute>
                    <BookingManagement />
                  </ProtectedRoute>
                } />
                <Route path="/providers" element={
                  <ProtectedRoute>
                    <ServiceProviderManagement />
                  </ProtectedRoute>
                } />
                <Route path="/reviews" element={
                  <ProtectedRoute>
                    <ReviewsModeration />
                  </ProtectedRoute>
                } />
                <Route path="/settings" element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                } />
                <Route path="/admin-settings" element={
                  <ProtectedRoute>
                    <AdminSettings />
                  </ProtectedRoute>
                } />
                <Route path="/cms" element={
                  <ProtectedRoute>
                    <CMS />
                  </ProtectedRoute>
                } />
                <Route path="/memberships" element={
                  <ProtectedRoute>
                    <AdminMembershipManagement />
                  </ProtectedRoute>
                } />
                <Route path="/subscription-plans" element={
                  <ProtectedRoute>
                    <AdminSubscriptionPlans />
                  </ProtectedRoute>
                } />
                <Route path="/admin/subscription-plans" element={
                  <ProtectedRoute>
                    <AdminSubscriptionPlans />
                  </ProtectedRoute>
                } />
                <Route path="/notifications" element={
                  <ProtectedRoute>
                    <NotificationsPage />
                  </ProtectedRoute>
                } />
                <Route path="/admin/inquiries" element={
                  <ProtectedRoute>
                    <InquiriesManagement />
                  </ProtectedRoute>
                } />
                <Route path="/admin/inquiries/:id" element={
                  <ProtectedRoute>
                    <InquiryDetail />
                  </ProtectedRoute>
                } />

                
                <Route path="/talent/login" element={<TalentLogin />} />
                <Route path="/talent/forgot-password" element={<TalentForgotPassword />} />
                <Route path="/talent/reset-password/:token" element={<TalentResetPassword />} />
                <Route path="/talent/dashboard" element={
                  <TalentLayout>
                    <TalentDashboard />
                  </TalentLayout>
                } />
                <Route path="/talent/profile" element={
                  <TalentLayout>
                    <TalentProfile />
                  </TalentLayout>
                } />
                <Route path="/talent/profile/edit" element={
                  <TalentLayout>
                    <TalentProfileEdit />
                  </TalentLayout>
                } />
                <Route path="/talent/services" element={
                  <TalentLayout>
                    <TalentServices />
                  </TalentLayout>
                } />
                <Route path="/talent/membership" element={
                  <TalentLayout>
                    <MembershipManagement />
                  </TalentLayout>
                } />
                <Route path="/talent/membership/select" element={<MembershipSelection />} />
                <Route path="/talent/membership/success" element={<MembershipSuccess />} />
                <Route path="/talent/membership/failed" element={<MembershipFailed />} />

                <Route path="/talent/portfolio" element={
                  <TalentLayout>
                    <TalentPortfolio />
                  </TalentLayout>
                } />
                <Route path="/talent/schedule" element={
                  <TalentLayout>
                    <TalentPlaceholder 
                      title="Schedule" 
                      description="Manage your availability and appointments"
                    />
                  </TalentLayout>
                } />
                <Route path="/talent/inquiries" element={
                  <TalentLayout>
                    <TalentInquiries />
                  </TalentLayout>
                } />
                <Route path="/talent/bookings" element={
                  <TalentLayout>
                    <TalentPlaceholder 
                      title="Bookings" 
                      description="View and manage your service bookings"
                    />
                  </TalentLayout>
                } />
                <Route path="/talent/reviews" element={
                  <TalentLayout>
                    <TalentReviews />
                  </TalentLayout>
                } />
                <Route path="/talent/payments" element={
                  <TalentLayout>
                    <TalentPlaceholder 
                      title="Payments" 
                      description="View your earnings and payment history"
                    />
                  </TalentLayout>
                } />
                <Route path="/talent/settings" element={
                  <TalentLayout>
                    <TalentPlaceholder 
                      title="Settings" 
                      description="Manage your account settings and preferences"
                    />
                  </TalentLayout>
                } />

                {/* Customer Routes */}
                <Route path="/customer/login" element={<CustomerLogin />} />
             
                <Route path="/customer/forgot-password" element={<CustomerForgotPassword />} />
                <Route path="/customer/reset-password/:token" element={<CustomerResetPassword />} />
                <Route path="/customer/dashboard" element={
                  <CustomerProtectedRoute>
                    <CustomerDashboard />
                  </CustomerProtectedRoute>
                } />
                <Route path="/customer/service-inquiry" element={
                  <CustomerProtectedRoute>
                    <ServiceInquiry />
                  </CustomerProtectedRoute>
                } />
                <Route path="/customer/messages" element={
                  <CustomerProtectedRoute>
                    <CustomerMessages />
                  </CustomerProtectedRoute>
                } />

                {/* Fallback route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </CustomerAuthProvider>
        </TalentAuthProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
